import { Tile } from '@almbrand/tile';

export interface TileComponentProps extends LocalId {
	icon: Icon;
	backgroundColor?: BackgroundColor;
	colorComplexion?: string;
	cssClass?: string;
	contentId: number;
	properties?: ImageProperties;
	title: string;
	url: Link;
	target?: '_self' | '_blank';
	bmetricId?: string;
}

export const TileComponent: React.FC<TileComponentProps> = ({
	icon,
	backgroundColor,
	contentId,
	// properties,
	title,
	url,
	target,
	useReadline,
	readlineId,
	bmetricId,
}) => {
	const rootUrl = window.location.origin;
	const { altText } = icon?.properties ?? {};

	return (
		<Tile
			id={useReadline && readlineId ? readlineId : contentId}
			className={bmetricId}
			title={title}
			icon={icon?.url}
			altText={altText ?? `Tile Icon ${altText}`}
			url={url?.url}
			target={target}
			backgroundColor={backgroundColor?.cssClass}
			trackingEvent={{
				event: 'trackNavigation',
				navigationAction: title ?? '',
				navigationDestination: `${rootUrl}${url?.url ?? ''}`,
				navigationType: 'tile',
			}}
		/>
	);
};
